import { render, staticRenderFns } from "./FormattedText.vue?vue&type=template&id=0a630812"
import script from "./FormattedText.vue?vue&type=script&lang=js"
export * from "./FormattedText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports